import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { FeaturedEvent } from "./components/FeaturedEvent";
import { About } from "./components/About";
import { Policies } from "./components/Policies";
import { Leadership } from "./components/Leadership";
import { News } from "./components/News";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { CookiePolicy } from "./components/CookiePolicy";
import { CookieBanner } from "./components/CookieBanner";
import { CookieWidget } from "./components/CookieWidget";
import { IubendaScript } from "./components/IubendaIntegration";
import { Toaster } from "./components/ui/sonner";

const HomePage = () => {
  return (
    <>
      <IubendaScript />
      <Header />
      <main>
        <Hero />
        <FeaturedEvent />
        <About />
        <Policies />
        <Leadership />
        <News />
        <Contact />
      </main>
      <Footer />
      <Toaster />
      <CookieBanner />
      <CookieWidget />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
